import { VariantType } from 'notistack';

// values type definition from react-intl FormattedMessage
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Values = Record<string, any>;

export class PoolNotification {
    public key: number;

    public static error(message: string, values?: Values): PoolNotification {
        return new PoolNotification(message, values, 'error');
    }

    public static success(message: string, values?: Values): PoolNotification {
        return new PoolNotification(message, values, 'success');
    }

    public static warning(message: string, values?: Values): PoolNotification {
        return new PoolNotification(message, values, 'warning');
    }

    public static info(message: string, values?: Values): PoolNotification {
        return new PoolNotification(message, values);
    }

    constructor(public message: string, public values?: Values, public variant?: VariantType) {
        this.key = new Date().getTime() + Math.random();
    }
}
